
import useTranslation from '../../hooks/useTranslation';
import Subtitle from '../Subtitle/Subtitle';

type Props = {
    employmentType: string | number | string[];
};

const EmploymentSubtitle = ({ employmentType }: Props) => {
    const translate = useTranslation();

    switch (employmentType) {
        case 'EMPLOYEE':
            return <Subtitle text={translate('page.employment.subtitle.employee')} />;
        case 'SUBSTITUTE':
            return <Subtitle text={translate('page.employment.subtitle.employee')} />;
        case 'SELF_EMPLOYED':
            return <Subtitle text={translate('page.employment.subtitle.self-employed')} />;
        case 'PENSIONER':
            return <Subtitle text={translate('page.employment.subtitle.pensioner')} />;
        case 'UNEMPLOYED':
            return <Subtitle text={translate('page.employment.subtitle.unemployed')} />;
        case 'STUDENT':
            return <Subtitle text={translate('page.employment.subtitle.student')} />;
        case 'DISABILITY_PENSIONER':
            return <Subtitle text={translate('page.employment.subtitle.disability-pensioner')} />;
        case 'REHABILITATION':
            return <Subtitle text={translate('page.employment.subtitle.rehabilitation')} />;
        default:
            return <></>;
    }
};

export default EmploymentSubtitle;
